// extracted by mini-css-extract-plugin
module.exports = {"SectionTitle":"styles_SectionTitle__Uqq0O"};